import { render, staticRenderFns } from "./OFilePreview.vue?vue&type=template&id=21b2e8c6&scoped=true&"
import script from "./OFilePreview.vue?vue&type=script&lang=js&"
export * from "./OFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b2e8c6",
  null
  
)

export default component.exports